import loadable from '@loadable/component';

export const WomanandhomeSiteWrapper = loadable(
  () => import(/* webpackChunkName: "womanandhome-site" */ './WomanandhomeSiteWrapper'),
);
